import "./Error404.scss";
import ErrorImage from ".././../image/ErrorImage.svg";
import Back from "../../components/error-back/Back";
import Error404Header from "../../components/error404-header/Error404Header";

function Page404() {
  return (
    <>
      <Error404Header />
      <div className="body">
        <img className="image" src={ErrorImage}></img>
        <div className="div">
          <h1 className="text404">404</h1>
          <h2 className="text">Page Not Found</h2>
          <p className="long-text">
            We are sorry, the page you requested could not be found.
          </p>
          <Back />
        </div>
      </div>
    </>
  );
}

export default Page404;
